var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandupix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5455 7.8295C19.1062 7.39017 18.3938 7.39017 17.9545 7.8295L12 13.784L6.04549 7.8295C5.60616 7.39017 4.89384 7.39017 4.45451 7.8295C4.01517 8.26884 4.01517 8.98116 4.45451 9.4205L11.2045 16.1705C11.6438 16.6098 12.3562 16.6098 12.7955 16.1705L19.5455 9.4205C19.9848 8.98116 19.9848 8.26884 19.5455 7.8295Z",
    fill: "#162766"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandupix);
export default __webpack_public_path__ + "static/media/expandupix.cc4b5405234ad4747bb1856701e0e8af.svg";
export { ForwardRef as ReactComponent };